import React from 'react';
import { Link } from 'react-router-dom';

const LeftSidebarUpper = ({ category }) => {
  const getSubcategoryRoute = (subcategory) => {
    const routeMap = {
      'T-Shirts': '/mens/topwear/tshirts',
      'Casual Shirts': '/mens/topwear/casual-shirts',
      'Formal Shirts': '/mens/topwear/formal-shirts',
      'Sweatshirts': '/mens/topwear/sweatshirts',
      'Sweaters': '/mens/topwear/sweaters',
      'Jackets': '/mens/topwear/jackets',
      'Blazers & Coats': '/mens/topwear/blazers-coats',
      'Suits': '/mens/topwear/suits',
      'Rain Jackets': '/mens/topwear/rain-jackets'
    };
    return routeMap[subcategory] || '#';
  };

  const getCategories = () => {
    switch(category) {
      case 'topwear':
        return [
          'T-Shirts',
          'Casual Shirts',
          'Formal Shirts',
          'Sweatshirts',
          'Sweaters',
          'Jackets',
          'Blazers & Coats',
          'Suits',
          'Rain Jackets'
        ];
      case 'bottomwear':
        return [
          'Jeans',
          'Casual Trousers',
          'Formal Trousers',
          'Shorts',
          'Track Pants & Joggers'
        ];
      case 'footwear':
        return [
          'Casual Shoes',
          'Sports Shoes',
          'Formal Shoes',
          'Sneakers',
          'Sandals & Floaters',
          'Flip Flops',
          'Socks'
        ];
      case 'indian-festive':
        return [
          'Kurtas & Kurta Sets',
          'Sherwanis',
          'Nehru Jackets',
          'Dhotis'
        ];
      case 'bottomwear':
        return [
          'Jeans',
          'Casual Trousers',
          'Formal Trousers',
          'Shorts',
          'Track Pants & Joggers'
        ];
      case 'sports-active':
        return [
          'Active T-Shirts',
          'Track Pants & Shorts',
          'Tracksuits',
          'Jackets & Sweatshirts',
          'Swimwear'
        ];
      case 'fashion-accessories':
        return [
          'Ties, Cufflinks & Pocket Squares',
          'Caps & Hats',
          'Mufflers, Scarves & Gloves'
        ];
      case 'innerwear-sleepwear':
        return [
          'Briefs & Trunks',
          'Boxers',
          'Vests',
          'Sleepwear & Loungewear',
          'Thermals'
        ];
      case 'indian-fusion-wear':
        return [
          'Kurtas & Suits',
          'Kurtis, Tunics & Tops',
          'Sarees',
          'Ethnic Wear',
          'Leggings, Salwars & Churidars',
          'Skirts & Palazzos',
          'Dress Materials',
          'Lehenga Cholis',
          'Dupattas & Shawls',
          'Jackets'
        ];
      case 'western-wear':
        return [
          'Dresses',
          'Tops',
          'Tshirts',
          'Jeans',
          'Trousers & Capris',
          'Shorts & Skirts',
          'Co-ords',
          'Playsuits',
          'Jumpsuits',
          'Shrugs',
          'Sweaters & Sweatshirts',
          'Jackets & Coats',
          'Blazers & Waistcoats'
        ];
      case 'lingerie-sleepwear':
        return [
          'Bra',
          'Briefs',
          'Shapewear',
          'Sleepwear & Loungewear',
          'Swimwear',
          'Camisoles & Thermals'
        ];
      case 'sports-wear':
        return [
          'Sports T-Shirts & Tops',
          'Track Pants & Shorts',
          'Tracksuits',
          'Sports Jackets',
          'Swimwear'
        ];
      case 'fashion-accessories':
        return [
          'Scarves & Stoles',
          'Caps & Hats',
          'Gloves'
        ];
      case 'boys-clothing':
        return [
          'T-Shirts',
          'Shirts',
          'Shorts',
          'Jeans',
          'Trousers',
          'Clothing Sets',
          'Ethnic Wear',
          'Track Pants & Pyjamas',
          'Jacket, Sweater & Sweatshirts',
          'Party Wear',
          'Innerwear & Thermals',
          'Nightwear & Loungewear',
          'Value Packs'
        ];
      case 'girls-clothing':
        return [
          'Dresses',
          'Tops',
          'Tshirts',
          'Clothing Sets',
          'Lehenga choli',
          'Kurta Sets',
          'Party wear',
          'Dungarees & Jumpsuits',
          'Skirts & shorts',
          'Tights & Leggings',
          'Jeans, Trousers & Capris',
          'Jacket, Sweater & Sweatshirts',
          'Innerwear & Thermals',
          'Nightwear & Loungewear',
          'Value Packs'
        ];
      case 'infants':
        return [
          'Bodysuits',
          'Rompers & Sleepsuits',
          'Clothing Sets',
          'Tshirts & Tops',
          'Dresses',
          'Bottom wear',
          'Winter Wear',
          'Innerwear & Sleepwear'
        ];
      default:
        return [
          'T-Shirts',
          'Casual Shirts',
          'Formal Shirts',
          'Sweatshirts',
          'Sweaters',
          'Jackets',
          'Blazers & Coats',
          'Suits',
          'Rain Jackets'
        ];
    }
  };

  return (
    <div className="space-y-2 pb-6 border-b border-gray-200">
      {getCategories().map((item, index) => {
        const isTopwear = category === 'topwear';
        const route = isTopwear ? getSubcategoryRoute(item) : null;
        
        return isTopwear && route ? (
          <Link 
            key={index} 
            to={route}
            className="flex items-center text-sm cursor-pointer hover:text-pink-600 py-1"
          >
            {item}
          </Link>
        ) : (
          <label key={index} className="flex items-center text-sm cursor-pointer hover:text-gray-600">
            <input type="checkbox" className="mr-2" />
            {item}
          </label>
        );
      })}
    </div>
  );
};

export default LeftSidebarUpper;
